import React from 'react'
import classNames from 'classnames'

function NamedBlock(props) {
    const {name, className, nameClassName, style, onClick, notHighlightImages, hasLine, children} = props;

    return (
        <div className={classNames("form-group configpageblock", className, (onClick && !notHighlightImages) && "clickable")} style={style} onClick={onClick ? onClick : undefined}>

            {name &&
            <div className={classNames("configpageblock-name", nameClassName)}>
                {name}
            </div>}

            {hasLine && <hr/>}

            {children &&
                children}
        </div>);
}

export default NamedBlock;